export default {
  'adyenMonthlyReport.column.card_brand': '卡类型',
  'adyenMonthlyReport.column.rate': '费率',
  'adyenMonthlyReport.column.payment_amount': '支付金额',
  'adyenMonthlyReport.column.payment_count': '支付数量',
  'adyenMonthlyReport.column.refund_amount': '退款金额',
  'adyenMonthlyReport.column.refund_count': '退款数量',
  'adyenMonthlyReport.column.fees': '费用',
  'adyenMonthlyReport.column.other_withholding': '其他费用',
  'adyenMonthlyReport.column.total': '总计',
};
